<template>
    <div>
        <!-- Receive Payments With Ease Section -->
        <section class="py-5 bg-white">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 text-center text-md-left">
                        <h1 class="mb-3 text-8 font-weight-bold">
                            Receive Payments With Ease Via Magetsi Billers
                        </h1>
                        <p class="text-3 mb-4 mt-3">
                            Receive payments seamlessly from international and local customers directly into your wallet through Magetsi’s Billers platform. A convenient way to expand your Zimbabwean business worldwide.
                        </p>
                        <div class="text-center text-md-left mt-4 mb-5">
                            <a href="/business/register" class="btn btn-registration-solid">SIGN UP</a>
                            <a href="/business/auth" class="btn btn-registration-outline">LOG IN</a>
                        </div>
                    </div>
                    <div class="col-md-6 text-center">
                        <img src="/images/biller.webp" class="img-fluid" alt="Magetsi Billers" style="border-radius: 10px;">
                    </div>
                </div>
            </div>
        </section>


        <!-- What is Magetsi Billers Section -->
        <div class="container my-5 text-3">
            <h2 class="text-center mb-5 font-weight-bold text-7">What is Magetsi Billers?</h2>
            <p class="text-center">
                Billers by Magetsi is a secure, and efficient payment platform designed to help organizations receive payments from customers across the globe and locally. Whether you’re a business with a subscription model, a church accepting tithes and offerings, or an NGO needing donor support, Billers streamlines the payment process.
            </p>
        </div>

        <!-- Who Can Use Billers Section -->
        <div class="container my-5">
            <h2 class="text-center mb-5 font-weight-bold text-7">Who Can Use Billers?</h2>
            <div class="row">
                <div class="col-md-4 text-center">
                    <h5 class="font-weight-bold">Businesses with Subscription Models</h5>
                    <p>Perfect for companies and organizations offering services or memberships that require recurring payments.</p>
                </div>
                <div class="col-md-4 text-center">
                    <h5 class="font-weight-bold">Churches & Religious Organizations</h5>
                    <p>Easily accept tithes, offerings, and other forms of giving from your community, no matter where they are located.</p>
                </div>
                <div class="col-md-4 text-center">
                    <h5 class="font-weight-bold">NGOs & Charities</h5>
                    <p>Receive donations and support from your international and local backers, helping to drive your mission forward.</p>
                </div>
            </div>
        </div>

        <!-- Why Choose Billers Section -->
        <section class="py-5 bg-light">
            <div class="container">
                <h2 class="text-center mb-5 font-weight-bold text-7">Why Choose Billers?</h2>
                <div class="row">
                    <div class="col-md-6 mb-4">
                        <h5 class="font-weight-bold">Convenient Way To Receive Cash</h5>
                        <p>Customers can quickly and securely send payments from anywhere, including the diaspora with their MasterCard or Visa Card.</p>
                    </div>
                    <div class="col-md-6 mb-4">
                        <h5 class="font-weight-bold">Secure, Reliable Platform</h5>
                        <p>Built with security in mind, Billers safeguards each transaction, ensuring data privacy and trust for every user.</p>
                    </div>
                    <div class="col-md-6 mb-4">
                        <h5 class="font-weight-bold">Subscription & Recurring Payments</h5>
                        <p>Ideal for businesses and organizations that rely on repeat payments, allowing you to expand your dealings hassle-free.</p>
                    </div>
                    <div class="col-md-6 mb-4">
                        <h5 class="font-weight-bold">Accessibility</h5>
                        <p>Customers can make payments through the Magetsi website from any part of the world.</p>
                    </div>
                </div>
                <div class="text-center">
                    <a href="/business/register" class="btn btn-registration-solid btn-lg mt-4 px-5">Start Receiving Payments</a>
                </div>
            </div>
        </section>

        <!-- Take Your Payment Collection to the Next Level Section -->
        <div class="container my-5">
            <h2 class="text-center mb-5 font-weight-bold text-7">Take Your Payment Collection to the Next Level</h2>
            <div class="row text-center">
                <div class="col-md-3">
                    <h5 class="font-weight-bold">Transparent Transactions</h5>
                    <p>Full transparency on all transactions with a downloadable transaction history.</p>
                </div>
                <div class="col-md-3">
                    <h5 class="font-weight-bold">Global Reach</h5>
                    <p>Collect payments from supporters and customers worldwide.</p>
                </div>
                <div class="col-md-3">
                    <h5 class="font-weight-bold">Consistent Payouts</h5>
                    <p>Enjoy a structured payout from your Magetsi Wallet.</p>
                </div>
                <div class="col-md-3">
                    <h5 class="font-weight-bold">Dedicated Support</h5>
                    <p>Our team is here to assist you in maximizing Billers’ potential for your organization.</p>
                </div>
            </div>
            <div class="text-center mt-4">
                <a href="/business/register" class="btn btn-registration-solid btn-lg px-5">Get Started Now</a>
                <a href='https://outlook.office365.com/owa/calendar/MagetsiDemo@magetsi.co.zw/bookings/' class="btn btn-registration-outline btn-lg px-5">Request a Demo</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Content',
};
</script>

<style scoped>
/* Style as per the original content */
h5 {
    font-weight: 600;
    font-size: 18px;
}
p {
    font-size: 16px;
    line-height: 1.6;
}
a {
    color: #023161;
    text-decoration: none;
}
.btn-registration-solid {
    background-color: #1A245C;
    color: white;
    border: 1px solid #1A245C;
    border-radius: 4px;
    padding: 8px 24px;
    font-weight: bold;
    text-align: center;
}
.btn-registration-outline {
    background-color: transparent;
    color: #1A245C;
    border: 1px solid #1A245C;
    border-radius: 4px;
    padding: 8px 24px;
    font-weight: bold;
    text-align: center;
}
.btn-registration-solid:hover,
.btn-registration-outline:hover {
    background-color: #1A245C;
    color: white;
}

.rounded-image {
    border-radius: 10px;
}

</style>
